import UploadImage from './UploadImage'

export default UploadImage
